import { useTheme, Grid, Typography, Box } from "@mui/material";
import { ProductCard } from "~components/atoms";
import { useRealtimeProductsContext } from "~contexts/RealtimeProducts";
import type { Product as IProduct } from "~api/stream/interfaces";
import { useSocketContext } from "~contexts/Socket";

const SelectedProducts = () => {
  const theme: any = useTheme();
  const { selectedProducts, setSelectedProducts } = useRealtimeProductsContext();
  const { socket } = useSocketContext();

  const deleteProduct = (value: IProduct) => {
    if (selectedProducts.find((product) => product === value)) {
      const actualProducts = selectedProducts.filter((product) => product !== value);
      setSelectedProducts(actualProducts);
      socket?.emit("setRealTimeProducts", actualProducts);
    }
  };

  const onClickCard = (value: IProduct) => {
    deleteProduct(value);
  };

  return (
    <Grid
      spacing={1}
      container
      direction="row"
      justifyContent="stretch"
      alignItems="center"
      sx={{ flex: "1", mb: "55px", minHeight: "240px", height: "240px" }}
    >
      {selectedProducts.length ? (
        selectedProducts.map((product, index) => (
          <Grid item key={index} xs={3} sx={{ mt: "20px" }}>
            <ProductCard
              productImage={product.images.thumbs[0]}
              productName={product.productName}
              productPrice={`R$ ${product.items[0]?.price.toFixed(2)}`}
              type="delete"
              isDisabled={!product.isDisabled}
              imageType="realtimeProduct"
              onClick={() => onClickCard(product)}
            />
          </Grid>
        ))
      ) : (
        <Box sx={{ width: "100%", textAlign: "center" }}>
          <Typography sx={{ color: theme.palette.grey[0], fontSize: "32px" }}>
            produto da vez vazio
          </Typography>
          <Typography>busque produtos e destaque</Typography>
        </Box>
      )}
    </Grid>
  );
};

export default SelectedProducts;
